import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { useNonFeatureFlaggedEvents } from './useNonFeatureFlaggedEvents';
import { ANON_EVENTS, EMBEDDED_EVENTS, JOURNEY_EXIT_EVENTS, WHATS_APP_EVENTS } from '../constants';
import {
  ANONYMOUS_USERS_CRITERIA_FEATURE_FLAG,
  EMBEDDED_MESSAGING_CORE_FEATURE_FLAG,
  WHATS_APP_EVENTS_FEATURE_FLAG,
  JOURNEY_EXIT_EVENTS_FEATURE_FLAG,
  WHATS_APP_EVENTS_GA_FEATURE_FLAG,
} from '../../featureFlags';
import { ClientDataType } from '../../types';

const filteredEventsByDataType = (dataType: ClientDataType, events: ClientDataType[]) =>
  !events.includes(dataType);

/**
 * This hook filters out any feature flagged events from "ClientDataType" if their feature flag isn't on
 */
export const useFilterNonFeatureFlaggedEvents = () => {
  const { isWhatsAppGAEnabled } = useWhatsAppMessageChannelFeature();

  const anonEvents = useNonFeatureFlaggedEvents(ANONYMOUS_USERS_CRITERIA_FEATURE_FLAG, ANON_EVENTS);
  const embeddedEvents = useNonFeatureFlaggedEvents(
    EMBEDDED_MESSAGING_CORE_FEATURE_FLAG,
    EMBEDDED_EVENTS,
  );
  const whatsAppEvents = useNonFeatureFlaggedEvents(
    isWhatsAppGAEnabled ? WHATS_APP_EVENTS_GA_FEATURE_FLAG : WHATS_APP_EVENTS_FEATURE_FLAG,
    WHATS_APP_EVENTS,
  );
  const journeyExitEvents = useNonFeatureFlaggedEvents(
    JOURNEY_EXIT_EVENTS_FEATURE_FLAG,
    JOURNEY_EXIT_EVENTS,
  );

  const eventsToFilterOut = [
    ...anonEvents,
    ...embeddedEvents,
    ...whatsAppEvents,
    ...journeyExitEvents,
  ];

  return (dataType: ClientDataType) => filteredEventsByDataType(dataType, eventsToFilterOut);
};
